import { PageContent } from '@/types/pages';

export const youHaveLoggedOut: PageContent = {
  title: 'You have logged out',
  backButton: false,
  contentBlocks: [
    {
      tag: 'p',
      text: 'If you were entering information, it has not been saved and you will need to re-enter it.',
    },
    {
      tag: 'p',
      text: 'To continue, close this tab and log in again.',
    },
  ],
};
